import { Collapse } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { MapTogglesProvider, useMapToggles } from '../Map/ToggleContext'; // Adjust the path as necessary
import DeviceSelectionRow from "../../components/Devices/DeviceSelectionRow";
import { useTranslation } from "react-i18next";
import Searchbar from '../Searchbar/Searchbar';
import Button from '../Buttons/Button';
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';

const CreateGroup = ({ groups, devices, setCreateGroup, saveGroup }) => {
    const { t } = useTranslation();
    const [groupName, setGroupName] = useState("")
    const [errorText, setErrorText] = useState("")
    const [searchText, setSearchText] = useState("")
    const [innerDevices, setInnerDevices] = useState([])
    const [allSelected, setAllSelected] = useState(false)

    const handleChange = (field, e) => {
        setErrorText("");
        if (field === "name") {
            setGroupName(e.target.value);
        }
    }


    const handleSave =() => {
        const checkedDevices = innerDevices?.filter((device) => device.selected).map((device) => device.id);
        saveGroup(groupName, checkedDevices)
    }

	const filterSearch = (text) => {
		if (text === "" || text === null) {
			setSearchText("");
			setInnerDevices(devices);
			return;
		}
		const match = devices?.filter((device) => {
			const item = text.toLowerCase();
			return device.name.toLowerCase().indexOf(item) > -1 || device.uniqueid.toLowerCase().indexOf(item) > -1;
		});
        const sorted = staticSort(match, "name")
		setInnerDevices(sorted);
		setSearchText(text);
	};

	const selectDevice = (id) => {
		const updatedDeviceList = [...devices];
		const index = updatedDeviceList?.findIndex((device) => device.id === id);
		const match = updatedDeviceList[index];

		if (match.selected !== true) {
			match.selected = true;
		} else {
			match.selected = false;
		}
		updatedDeviceList[index] = match;
		setInnerDevices(updatedDeviceList);
	};

    useEffect(() => {
        // bail out if list hasn't been loaded yet
        if (!Array.isArray(devices)) return;

        setInnerDevices((prev) =>
            prev.map((device) => ({
                ...device,
                selected: allSelected
                    ? true
                    : false, // else clear all
            }))
        );
    }, [allSelected]);

    useEffect(() => {
        const sorted = staticSort(devices, "name")
        setInnerDevices(sorted)
    }, [devices])
   
    return(
        <>
            <div className="d-flex flex-column p-3 bg-white">
                <h3 className="">{t("devices.create_group")}</h3>
                <div className="d-flex flex-row flex-fill my-3">
                    <div className="d-flex flex-column w-50">
                        <h4 className="primary">{t("geofence.name")}</h4>
                        <form>
                            <div className="form-group d-flex align-items-center">
                                <input
                                    type="text"
                                    className="form-control bg-grey"
                                    id="name"
                                    value={groupName}
                                    onChange={(e) => {
                                        handleChange("name", e);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // Prevent the default Enter key behavior
                                            handleSave()
                                            
                                        }
                                    }}
                                />
                                <div className="invalid-feedback ms-1 bottom">{errorText === "" ? "" : errorText}</div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="d-flex flex-column">
                    <h4 className="primary mb-2">{t("devices.choose_device")}</h4>
                    <Searchbar className="mb-3" submitSearch={(data) => filterSearch(data)} />
                    <div className={`group_device_list scrollable-y shadow ${!devices.some((device) => device.selected) ? "" : "pushed"}`}>
                    <DeviceSelectionRow
                        text={t("devices.choose_all")}
                        index={-1}
                        selected={innerDevices.filter(device => device.groupid === null).every(device => device.selected)}
                        onClick={() => {
                            const allSelected = innerDevices.filter(device => device.groupid === null).every(device => device.selected);
                            setAllSelected(!allSelected);
                        }}
                    />		

                    </div>
                    <div className={`d-flex justify-content-end mt-3 ${!devices?.some((device) => device.selected) && "d-none"}`}>
                        <Button btnClass="btn-secondary me-3" onClick={() => setCreateGroup(false)}>
                            {t("devices.cancel")}
                        </Button>
                        <Button btnClass="btn-primary" onClick={() => handleSave()}>
                            {t("devices.save")}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}


export default CreateGroup;